import { render, staticRenderFns } from "./LoginSaleAccount.vue?vue&type=template&id=4dac8771&scoped=true&"
import script from "./LoginSaleAccount.vue?vue&type=script&lang=js&"
export * from "./LoginSaleAccount.vue?vue&type=script&lang=js&"
import style0 from "./LoginSaleAccount.vue?vue&type=style&index=0&id=4dac8771&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dac8771",
  null
  
)

component.options.__file = "LoginSaleAccount.vue"
export default component.exports